module.exports = __webpack_public_path__ + "static/media/sambarvadai.7615ee14.jpg";